<template>
<div class="TcCancelAppointment fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div
      class="inline-block bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all align-middle max-w-lg w-full">
      <div class="bg-white px-4 py-10">
        <div class="flex flex-col items-center">
          <div class="mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full bg-orange-400">
            <svg class="h-12 w-12 text-white" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" stroke="none" aria-hidden="true">
              <path d="M 11.977 1.771 C 13.83 1.758 14.617 2.765 14.617 3.75 L 13.784 15.339 C 13.784 16.324 12.985 17.123 12 17.123 C 11.015 17.123 10.216 16.324 10.216 15.339 L 9.447 3.764 C 9.447 2.779 10.124 1.784 11.977 1.771 Z" fill="currentColor"/>
              <circle fill="currentColor" cx="12" cy="21.5" r="2.5"/>
            </svg>
          </div>
          <div class="mt-5 text-center">
            <h3 class="text-2xl leading-6 font-medium text-gray-900" id="modal-title">
              ¿Estas seguro de cancelar tu cita?
            </h3>
            <hr class="mt-5 mb-3 w-10 mx-auto">
            <div class="mt-2">
              <div class="text-xl text-gray-500">
                <div class="flex justify-center items-center mx-auto mb-3">
                  <svg class="h-6 w-6 mr-3" :style="{color:$root.delegationColor(appointment.delegation_id)}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="12" fill="currentColor"/>
                  </svg>
                  <h4>{{ appointment.delegation_name }}</h4>
                </div>
                <div>Cita {{ appointment.type == 'phone_call' ? 'Telefónica':'Presencial'}}</div>
                <div>{{appointment.reserved_at.toDate()}}</div>
                <div>{{appointment.reserved_at.toTime()}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-gray-50 py-3 px-6 flex flex-row-reverse justify-center">
        <button
          @click="$parent.deleteAppointment(appointment.id)"
          type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-400 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
          Confirmar
        </button>
        <button @click="$parent.canceling=false"
          type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          &#9001; Atrás
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'TcCancelAppointment',
  props: ['appointment'],
  data () {
    return {}
  }
}
</script>